import $axios from './axios.js'

export const getList = (option)=>{
	
	return new Promise((resolve,reject)=>{
		let opt = option ? option : null;
		let opt_default = {
			url:'',				//接口地址，不用前缀
			data:{},			//其他参数
			numName:'pageNum',	//分页页码
			sizeName:'pageSize',//分页数量
			isReach:false,		//是否刷新列表
			page:null,			//当前页面的this
			listName:'listInfo',//列表名称
			cbListFn:null,		//列表返回字段（具体看接口返回）
			handleFn:null,		//处理数据列表
			// success: null,  	//成功且code=0时回调函数
			// fail: null,     	//失败回调函数
			// complete: null   	//调用接口完回调函数
		};
		opt = opt ? Object.assign(opt_default, opt) : opt_default
		
		var _this = opt.page
		var listName = opt.listName
		if(opt.isReach){
			_this[listName][opt.numName] = 1
		}
		
		opt.data[opt.numName] = _this[listName][opt.numName]?_this[listName][opt.numName]:1
		opt.data[opt.sizeName] = _this[listName][opt.sizeName]? _this[listName][opt.sizeName]:10
		$axios({
			url:opt.url,
			params:opt.data,
		}).then(res=>{
			
			if(res.code==200){
				
				var list = opt.cbListFn?opt.cbListFn(res):res.data	//这里的list需要根据实际接口返回的字段
				
				if(list.length < _this[listName][opt.sizeName]){
					_this[listName].finished = true
					if( list.length == 0 && _this[listName][opt.numName]>1){ return }
				}
				_this[listName].loading = false
				_this[listName].total = res.total // 数据总条数
				
				if(opt.handleFn){	//处理列表的每一项
					list.forEach(item=>{
						item = opt.handleFn(item)
					})
				}
				
				if(!opt.isReach && _this[listName][opt.numName] > 1){
					list = _this[listName].list.concat(list)
				}
				//console.log('list',listName,list)
				_this[listName].list = list
				_this[listName][opt.numName]++
				if(res.total){
					_this[listName].total = res.total
				}
				
				resolve(list)
			}else{
				resolve(res)
			}
		}).catch(err=>{
			reject(err)
		})
	
	})
	
}



// WEBPACK FOOTER //
// ./src/static/js/list-vant.js